import type { GridsterEngine } from './gridster-engine';
import type { GridsterItemInstance } from './gridster-item-instance';

export class GridsterSwap {
  private swapedItem: GridsterItemInstance | undefined;

  constructor(
    private gridsterItem: GridsterItemInstance,
    private gridster: GridsterEngine
  ) {}

  swapItems(): void {
    if (!this.gridster.options.swap) {
      return;
    }
    this.checkSwapBack();
    this.checkSwap(this.gridsterItem);
  }

  private checkSwapBack(): void {
    if (!this.swapedItem) {
      return;
    }
    const $item = this.swapedItem.$item;
    const item = this.swapedItem.item;
    const x = $item.x;
    const y = $item.y;
    $item.x = item.x || 0;
    $item.y = item.y || 0;
    if (this.gridster.checkCollision($item)) {
      $item.x = x;
      $item.y = y;
    } else {
      this.swapedItem.setSize();
      this.gridsterItem.$item.x = this.gridsterItem.item.x || 0;
      this.gridsterItem.$item.y = this.gridsterItem.item.y || 0;
      this.swapedItem = undefined;
    }
  }

  restoreSwapItem(): void {
    if (!this.swapedItem) {
      return;
    }
    const $item = this.swapedItem.$item;
    const item = this.swapedItem.item;
    $item.x = item.x || 0;
    $item.y = item.y || 0;
    this.swapedItem.setSize();
    this.swapedItem = undefined;
  }

  setSwapItem(): void {
    if (!this.swapedItem) {
      return;
    }
    this.swapedItem.checkItemChanges(this.swapedItem.$item, this.swapedItem.item);
    this.swapedItem = undefined;
  }

  private checkSwap(pushedBy: GridsterItemInstance): void {
    const $item = pushedBy.$item;
    const item = pushedBy.item;
    const collision = this.gridster.options.swapWhileDragging
      ? this.gridster.checkCollisionForSwapping($item)
      : this.gridster.checkCollision($item);

    if (collision && collision !== true && collision.canBeDragged()) {
      const collide$item = collision.$item;
      const copyX = $item.x;
      const copyCollisionX = collide$item.x;
      const copyCollisionY = collide$item.y;
      const copyY = $item.y;
      const diffX = copyX - copyCollisionX;
      const diffY = copyY - copyCollisionY;
      collide$item.x = item.x - diffX;
      collide$item.y = item.y - diffY;
      $item.x = collision.item.x + diffX;
      $item.y = collision.item.y + diffY;
      if (this.gridster.checkCollision(collide$item) || this.gridster.checkCollision($item)) {
        $item.x = copyX;
        $item.y = copyY;
        collide$item.x = copyCollisionX;
        collide$item.y = copyCollisionY;
      } else {
        collision.setSize();
        this.swapedItem = collision;
        if (this.gridster.options.swapWhileDragging) {
          pushedBy.checkItemChanges(pushedBy.$item, pushedBy.item);
          this.setSwapItem();
        }
      }
    }
  }
}
